import React, { ReactElement } from 'react';
import CenteredContainer from '../CenteredContainer';
import IAdditionalResourcesSectionProps from './IAdditionalResourcesSectionProps';
export default function AdditionalResourcesSection(props: IAdditionalResourcesSectionProps): ReactElement {
    return <div className='row'>
        <CenteredContainer>
            {props.children}
        </CenteredContainer>
    </div>;
}